import { useMemo } from "react";
import useAuth from "./useAuth";
import useAllFields from "./useAllFields";
import useConfigurableFields from "./configurable-fields";
import { isFieldSettingEnabled } from "../utils/fieldSettings";
import {
  shipments,
  getOrders,
  getInventoryItems,
  getInventoryRequest,
  getshoppingCart,
  reservations,
} from "../constants/fields";

export default function useEnabledProjectFields(fieldSettings = null) {
  const { user } = useAuth();
  const { settings } = user.company;
  const { identifiers, descriptiveInfo, warehouseInfo, originInfo, destinationInfo, electricalInfo, plumbingInfo, mechanicalInfo } = useAllFields();
  const { configurableFields = [] } = useConfigurableFields();

  const orders = getOrders({
    dateName: settings.delivery_date_label,
    projectName: settings.filter_field2,
    configurableField3Name: settings.inventory_request_configurable_field_3_name,
  });

  const inventoryItems = getInventoryItems(settings);
  const inventoryRequest = getInventoryRequest({ 
    commentsName: settings.comments_label,
    configurableField1Name: settings.inventory_request_configurable_field_1_name,
    configurableField2Name: settings.inventory_request_configurable_field_2_name,
    configurableField3Name: settings.inventory_request_configurable_field_3_name,
    configurableField4Name: settings.inventory_request_configurable_field_4_name,
    configurableField5Name: settings.inventory_request_configurable_field_5_name,
  });
  const shoppingCart = getshoppingCart({
    projectLabel: settings.filter_field2,
    quantityLabel: settings.quantity_label,
    descriptionComments: settings.description_comments_label,
    ...settings,
  });

  // Fetch for only asset field categories for PDF configuration
  // Excludes: shipments, inventoryItems, inventoryRequest, shoppingCart, orders, reservations
  const allFieldCategories = useMemo(() => [
    ...identifiers,
    ...descriptiveInfo,
    ...warehouseInfo,
    ...originInfo,
    ...destinationInfo,
    ...electricalInfo,
    ...plumbingInfo,
    ...mechanicalInfo,
    ...configurableFields, // User configurable custom fields
  ], [
    identifiers,
    descriptiveInfo,
    warehouseInfo,
    originInfo,
    destinationInfo,
    electricalInfo,
    plumbingInfo,
    mechanicalInfo,
    configurableFields,
  ]);

  const enabledFields = useMemo(() => {
    if (!fieldSettings) return [];
    return allFieldCategories.filter(([fieldName]) => {
      return isFieldSettingEnabled(fieldSettings, fieldName);
    });
  }, [fieldSettings, allFieldCategories]);

  return enabledFields;
}